import { LegalPage } from '@/features/legal/components/legal-page'

export default function RefundPolicyPage() {
  return <LegalPage documentKey="refund" />
}
